import { Injectable } from '@angular/core';
import { BaseAPIClass } from '../class';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GCategoriaService extends BaseAPIClass {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/gcategorias';
  }

  enableCategoria(id: number) {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }
  
  enabledMenu(id: any) {
    return this.httpClient
      .get(this.baseUrl + '/esmenu/'+ id)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  getMenuList() {
    return this.httpClient.get(this.baseUrl + '/menu');
  }

  getByDir(dir: string) {
    return this.httpClient.get(`${this.baseUrl}/dir/${dir}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }
  
  categoriaUsuarios(id:any) {
    return this.httpClient.get(this.baseUrl + '/usuarios/'+id);
  }
}